import React, { Component } from 'react';
// import logo from './logo.svg';
import './App.css';
import SideNav from './components/sideNav';
import About from './components/about';
import Experience from './components/experience';
import Education from './components/education';
import Skills from './components/skills';
import Interests from './components/interests';
import Awards from './components/awards';





class App extends Component {
  render(){
    return (
      <div className="container-fluid p-0" id="page-top">
        <SideNav />
        <About />
        <Experience />
        <Education />
        <Skills />
        <Interests />
        <Awards />
      </div>
    );
  }
}

export default App;
